import { Folder } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useState } from "react";
import { useRevalidator } from "react-router-dom";

import Colors from "../../../../global/Colors";
import CustomDataGrid from "../../../../ui library/components/data-grid/CustomDataGrid";
import { useDocumentListStore } from "../hooks/useDocumentListStore";

export default function FolderList({ folders, setCurrentFolder }) {
  const { setFolderId, setLoading } = useDocumentListStore();
  const { revalidate } = useRevalidator();
  const [activeRowId, setActiveRowId] = useState(null);

  const columns = [
    {
      field: "folderName",
      headerName: "Name",
      minWidth: 175,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <Box className="flex w-full items-center p-0">
          <div className="flex h-full items-center justify-center">
            <Folder className="mx-2 text-gray-500" />
            <span>{row.folder_name}</span>
          </div>
        </Box>
      ),
    },
    {
      field: "documentCount",
      headerName: "Document Count",
      minWidth: 175,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <Box className="flex w-full justify-start px-3">
          <span>{row.folder_count}</span>
        </Box>
      ),
    },
  ];

  function getRowId(row) {
    return row.folder_id;
  }

  const onHandleClick = (row) => {
    if (row.folder_count > 0) {
      setLoading(true);
      setFolderId(row.folder_id);
      revalidate();
    }
  };

  return (
    <Box className="flex h-fit w-full items-center justify-center overflow-y-auto p-4 pb-0">
      <CustomDataGrid
        columns={columns}
        getRowId={getRowId}
        disableRowSelectionOnClick
        disableMultipleRowSelection
        getRowHeight={() => "160"}
        getEstimatedRowHeight={() => "100"}
        rowSelection={false}
        rows={folders ?? []}
        onRowClick={(params) => {
          if (params.row.folder_count > 0) {
            setActiveRowId(params.id);
            onHandleClick(params.row);
            setCurrentFolder(params.row["folder_name"]);
          }
        }}
        getRowClassName={(params) => {
          let base = params.row.folder_count === 0 ? "disabled" : "";
          if (params.id === activeRowId) {
            base += " active-row";
          }
          return base;
        }}
        sx={{
          "& .MuiDataGrid-cell": {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            padding: "0 0",
            borderBottom: `1px solid ${Colors.gray[100]}`,
            overflow: "visible",
            boxSizing: "border-box",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
          "& .MuiDataGrid-row.disabled": {
            pointerEvents: "none",
            cursor: "default",
          },
          "& .MuiDataGrid-row.active-row": {
            backgroundColor: Colors.gray[200],
          },
        }}
      />
    </Box>
  );
}
